type MenuItem = {
	title: string;
	path?: string;
	children?: MenuItem[];
};
export const menuData: MenuItem[] = [
	{
		title: '',
		children: [
			{title: 'Home', path: '/'},
			{title: 'About Us', path: '/about-us'},
			{title: 'Services', path: '/services'},
			{title: 'Companies', path: '/companies'}
		]
	},
	{
		title: '',
		children: [
			{title: 'Partners', path: '/partners'},
			{title: 'Contact', path: '/contact-us'},
			{title: 'Privacy Policy', path: '/privacy-policy'}
			// {title: 'Team', path: '/team'}
		]
	}
];
